import React from 'react';

const WhatToExpect = () => {
  return (
    <section className="py-[100px] bg-white opacity-0 animate-fadeIn-delayed-2">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-8 text-[#333333] text-center">
          What to Expect
        </h2>
        <div className="max-w-[800px] mx-auto">
          <p className="text-[1.3rem] mb-8 font-[1.1rem]">
            <strong>This is not a keynote or lecture.</strong> It's an intimate peer-to-peer conversation among senior 
            leaders who are actively navigating the integration of AI in their organizations.
          </p>
          <p className="text-[1.1rem] mb-6">
            You'll engage in unfiltered discussions about the challenges and opportunities that arise when introducing AI 
            technologies to workplace culture. Share experiences, gain fresh perspectives, and build connections with fellow 
            executives facing similar transformations.
          </p>
          <p className="text-[1.1rem] mb-6">
            The session spans two hours over curated refreshments, designed to facilitate meaningful dialogue rather than 
            presentations. Our commitment is to quality of conversation over quantity of content.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;

